import { Link } from 'react-router-dom';
import { ArrowUpRight, Mail, MapPin, Phone } from 'lucide-react';
import Logo from './Logo';
import { COMPANY, NAV_LINKS, SERVICES } from '../data/site';

export default function Footer() {
  return (
    <footer className="relative bg-black text-white border-t border-white/10 mt-24">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4 space-y-6">
          <Logo size={156} forceWhite />
          <p className="text-white/60 text-sm max-w-xs leading-relaxed">
            Serrurerie, métallerie et vitrerie à Paris 8. Installation, rénovation et
            dépannage pour particuliers, professionnels et copropriétés.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-white text-black px-4 h-11 font-mono text-[11px] tracking-[0.22em] uppercase hover:bg-white/90"
          >
            Demander un devis <ArrowUpRight size={14} strokeWidth={1.5} />
          </Link>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-5">Navigation</div>
          <ul className="space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="link-underline text-sm text-white/75 hover:text-white">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-5">Services</div>
          <ul className="space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/${s.slug}`} className="link-underline text-sm text-white/75 hover:text-white">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-5">Contact</div>
          <ul className="space-y-3.5 text-sm text-white/75">
            <li className="flex items-start gap-3"><MapPin size={15} strokeWidth={1.5} className="mt-0.5" /><span>{COMPANY.address}<br />{COMPANY.city}</span></li>
            <li><a className="flex items-center gap-3 link-underline" href={`tel:${COMPANY.phoneTel}`}><Phone size={15} strokeWidth={1.5} />{COMPANY.phone}</a></li>
            <li><a className="flex items-center gap-3 link-underline break-all" href={`mailto:${COMPANY.email}`}><Mail size={15} strokeWidth={1.5} />{COMPANY.email}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 font-mono text-[10px] tracking-[0.18em] uppercase text-white/45">
          <div>© Groupe Ponthieu — Tous droits réservés.</div>
          <div className="flex items-center gap-6">
            <Link to="/mentions-legales" className="link-underline">Mentions légales</Link>
            <Link to="/confidentialite" className="link-underline">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
